import Service from "../Service";
const resource = "MangoTraining/";

export default {
  save(formData, requestID) {
    return Service.post(resource + "save", formData, {
      params: { requestID },
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  detect(formData, requestID) {
    return Service.post(resource + "detect", formData, {
      params: { requestID },
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  startTraining(requestID) {
    return Service.post(resource + "train/start", {}, {
      params: { requestID }
    });
  },
  getTrainingStatus(requestID) {
    return Service.get(resource + "train/status", {
      params: { requestID }
    });
  },
  getModelVersion() {
    return Service.get(resource + "model/version");
  }
};